// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { Message } from 'element-ui'
import store from './store'

import 'babel-polyfill'
import axios from '@/utils/request'
import config from '../static/lib/config'


import animated from 'animate.css'

import '../static/css/bootstrap.css'
import '../static/css/common.css'
import '../static/css/scrollbar.css'
import '../static/css/css.css'
import '../static/css/aos.css'
import '../static/css/swiper.css'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(animated)
if (Number.parseInt === undefined) Number.parseInt = window.parseInt
if (Number.parseFloat === undefined) Number.parseFloat = window.parseFloat

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})


Vue.prototype.imgBaseUrl = config.proxyUrl;



// WEBPACK FOOTER //
// ./src/main.js